import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
//import './index.css';
//import * as serviceWorker from './seviceWorker';

ReactDOM.render(
<App />, 
    document.getElementById('root'));

//::::::::::::





